import { apiClientConfigurationSchema as o } from "@scalar/types/api-reference";
import { inject as i, ref as t } from "vue";
const e = Symbol(), m = () => i(e, t(o.parse({})));
export {
  e as CLIENT_CONFIGURATION_SYMBOL,
  m as useClientConfig
};
